import { render, staticRenderFns } from "./CompactPositionList.vue?vue&type=template&id=98e88da8"
import script from "./CompactPositionList.vue?vue&type=script&lang=js"
export * from "./CompactPositionList.vue?vue&type=script&lang=js"
import style0 from "./CompactPositionList.vue?vue&type=style&index=0&id=98e88da8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports